<template>
  <div id="admin">
    <HeaderView />
    <a-layout>
      <SliderView />
      <a-layout-content style=" display: flex; justify-content: center;">
        <router-view class="admin-layout-content"></router-view>
      </a-layout-content>
    </a-layout>
    <FooterView />
  </div>
</template>

<script>
import HeaderView from '../components/header'
import SliderView from '../components/slider'
import FooterView from '../components/footer'

export default {
  components: {
    HeaderView,
    SliderView,
    FooterView
  },
  mounted () {
    if (sessionStorage.user === undefined) {
      this.$router.push('/admin/login')
    } else {
      this.$store.state.user = JSON.parse(sessionStorage.user)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/contianers/admin.vue